import { useState, useEffect, useMemo } from 'react';
import { flushSync } from "react-dom";
import { Row, Col, Modal, ModalHeader, ModalBody, ModalFooter, Button, Form, Input, Label, Spinner, FormGroup } from 'reactstrap';
import { FaChevronRight, FaChevronLeft } from 'react-icons/fa';
import './Infrastructure.css';
import { useSearchParams } from 'react-router-dom';
import toast, { Toaster } from 'react-hot-toast';
import axios from 'axios';
import SpinnerContainer from '../Utilities/Ui/SpinnerContainer';
import ItemCommonTop from '../ItemPopup/ItemCommonTop';
import ItemCommonBottom from '../ItemPopup/ItemCommonBottom';
import ItemFooter from '../ItemPopup/ItemFooter';
import Action from '../Action/Action';
import ItemBasedAction from '../Action/ItemBasedAction';
import MapView from '../Map/MapView';
import NonMapView from '../ItemsView/NonMapView';
import MaintenancePlan from '../MaintenancePlan/MaintenancePlan';
import InfrastructureItemSpecView from './InfrastructureItemSpecView'
import Validate from '../Validate/Validate';
import ToggleSwitch from '../ThreeStateToggle/ToggleSwitch';
import { useNavigate, useLocation } from "react-router-dom";
import RiskSummary from '../ItemsView/RiskSummary';
import ItemTypeListViewForMap from '../ItemsView/ItemTypeListViewForMap';
import Draggable, { DraggableCore } from 'react-draggable';
import { ToastContainer, toast as toastytoast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { convertToRaw, EditorState, convertFromHTML, ContentState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "draft-js/dist/Draft.css";
import draftToHtml from "draftjs-to-html";
import useLocalStorage from "../Utilities/Hooks/useLocalStorage";
import { apiGet, apiPost } from "../Utilities/Hooks/apiWrapper";

function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
        width,
        height
    };
}

function useWindowDimensions() {
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return windowDimensions;
}


const Infrastructure = ({ refreshToken,handleWizardChanged, handleWizardChangedBack, handleMoveToNextPage, pageSection }) => {
    const [roleName, setRoleName] = useState(localStorage.getItem("roleName")); const [imageUploadList, setImageUploadList] = useState([]);
    const [farmRoleName, setFarmRoleName] = useLocalStorage('farmRoleName', null);
    const [isNextButtonVisible, setIsNextButtonVisible] = useState(false); const { height, width } = useWindowDimensions();
    const [searchParams, setSearchParams] = useSearchParams(); const [toggleSwitch, setToggleSwitch] = useState('map & details'); const [isThisPageCompleted, setIsThisPageCompleted] = useState(false); const [actionsCount, setActionsCount] = useState(0);
    const { state } = useLocation(); const [saving, setSaving] = useState(''); const [itemDeletesaving, setItemDeleteSaving] = useState('');
    const navigate = useNavigate();
    const [formErrors, setFormErrors] = useState({});
    const [farmId] = useState(localStorage.getItem("defaultFarmId"));
    const [userId] = useState(localStorage.getItem("loggedInUserId"))
    const [loading, setLoading] = useState(true);
    const [show_HistoricalActions, setShow_HistoricalActions] = useState(false);
    const [show_SectionComment, setShow_SectionComment] = useState(false);
    const [infrastructure, setInfrastructure] = useState({
        outlineList: [], itemList: [], itemTypes: [], uniqueItemTypes: [], itemFieldTypes: [], lookUpList: [], Section: pageSection.Section, SectionName: 'Infrastructure', SectionObj: {}, isWizardCompleted: false,
        outlineCenter: {}, farmCenterTypeModel: {}, outlineItemTypes: [], sectionComment: '', isMapOnly: pageSection.IsMapOnly, isMapRisk: pageSection.IsMapRisk
    });
    const [largeEnterpriseDetails, setLargeEnterpriseDetails] = useState({ isLargeEnterprise: false, LMUList: [], selectedLMUId: 0, isSmallEnterpriseShow: false })
    const [typeid, setTypeId] = useState(0);
    const [mapDetails, setMapDetails] = useState({
        isOutlinePage: false, isLMUPage: false, isCenterReq: false, isFarmCenterEditable: false,
        isFarmOutlineEditable: false, zoomLevel: 5, polyType: '', itemsEditable: false, highlighteditemId: 0, isClear: false, showLabel: true
    });
    const [riskLookupList, setRiskLookupList] = useState({ riskList: [], categoryList:[], enterpriseTypes: [], luenterpriseTypes: [], contaminants: [], riskDataGroups: [], activityGroups: [], activitySubGroups: [], tempActivitySubGroups: [], LUEnterpriseTypes: [] });
    const [itemPopup, setItemPopup] = useState({ showItemPopup: false, mapitem: [], farmId: farmId, id: 0, itemId: 0, markertype: '', canArchive: true, isMapOnly: pageSection.IsMapOnly });
    const [itemPopupHeader, setItemPopupHeader] = useState({
        page: 'Infrastructure', lmu: '', LMUId: 0, itemTypeName: '', LMUIds: '',
        itemTypeId: 0, Name: '', isDragged: false, Description: '', color: "#21b546", isEdited: false, itemTypeDescription: '', watertakeType: 0, watertakeTypeList: []
    });
    const [itemPopupMaptype, setItemPopupMaptype] = useState({ markertype: '', area: 0.0, perimeter: 0.0, coordinates: '', });
    const [itemPopupBiodiversity, setItemPopupBiodiversity] = useState({ isVisible: false, isItemToBiodiversity: false, biodiversityComment: '' });
    const [itemPopupRisk, setItemPopupRisk] = useState({
        isRisk: 'No', riskComment: '', enterprises: [], contaminants: [], riskDataGroups: [], activityGroups: [], activitySubGroups: [], likelihood: '', impact: '',
        showEnterprise: true,category:'',significance:'',riskId:[]
    });
    const [itemPopupAchievements, setItemPopupAchievements] = useState({ isAchievementsNotes: false, achievementsComment: '', isExpand :false });

    const [itemPopupItemFeild, setItemPopupItemFeild] = useState({
        itemTypeId: 0,
        itemFieldTypes: []
    });
    const [itemPopupItemSepcQ, setItemPopupItemSepcQ] = useState({
        AgChemicalSpillPrevention: '',
        DairySize: 0,
        IsYardRoofed: false,
        InShedFeeding: false,
        FertiliserRunoffPrevention: '',
        LeakageControls: '',
        BarnSize: 0,
        BarnOutdoorAreaSize: 0,
        OtherWaterTakes: 0,
        IsStructureLined: false,
        IsStructureCovered: false,
        LiquidEffluentAppliedIn: 0,
        IsSolidsSeperatedFromLiquidEffluent: false,
        IsLiquidEffluentTreatedSameAsDairyEffluent: false,
        LiningMaterial: '',
        StructureCleanedOn: 0,
        PadType: '',
        ShedUse: '',
        SilageLeachateControls: '',
        StockYardType: '',
        YardEffluentControls: '',
        UnderpassEffluentManagement: '',
        Recycling: '',
        WasteCollection: '',
        WatermeterType: 0,
        DataCaptureType: 0,
        IsConsentRequired: false,
        IsDischargeContained: false,
        PurposeOfWatertake: 0,
        WhatIsStationMeasuring: [], HowIsTheDataMonitored: '',
        WhatIsStationMeasuringValues: '',
        HAILsite: '',
        FrostProtectionType: '',
        ConsentNumber: '',
        ManageWaterUse: '',
        IsMarcgreenspread: false,
        IsMarcstored: false,
        ContainmentSystem: '',
        IsTthisWithin20m: false,
        IsItCovered: false,
        Height: 0,
        Thickness: 0,
        BufferWidth: 0,
        Areaperimeterbuffered: 0,
        DetailAnyCutOut: '',
        CurrentUsed: '', IsIrrigationArea: '', IsFrostProtectionArea: '', IsSprayArea: '', IsBufferZone: '', OtherTypeOfBufferZone: '', TypeOfBufferZone:''
    });

    const [itemDeletePopup, setItemDeletePopup] = useState({ showItemDeletePopup: false, itemId: 0 });
    const [actionPopup, setActionPopup] = useState({ isHavingItemBasedAction:false, showActionPopup: false, itemId: 0, itemTypeId: 0, itemName: '', actionId: 0 });
    const [wholeFarmActionPopup, setWholeFarmActionPopup] = useState({ showActionPopup: false, itemId: 0, itemTypeId: 0, itemName: '', actionId: 0 });
    const [maintenancePlanPopup, setMaintenancePlanPopup] = useState({ showMaintenancePlanPopup: false, itemId: 0, itemTypeId: 0, itemName: '', actionId: 0 });
    const [toggleItemTypeListState, setToggleItemTypeListState] = useState({ isOpen: false, isIconUp: false });
    const [toggleItemTypeState, setToggleItemTypeState] = useState({itemTypeId : 0, isOpen: false, isIconUp: false });
    const [toggleItemState, setToggleItemState] = useState({ itemId: 0, isOpen: false, isIconUp: false });
    const [riskSummaryPopup, setRiskSummaryPopup] = useState({ showriskSummary: false });
    const [popupAction, setPopupAction] = useState('');

    const handleMultiSelectChange = (e) => {
        var WhatIsStationMeasuringValues = '';
        e.forEach(function (element) {
            if (WhatIsStationMeasuringValues == '') {
                WhatIsStationMeasuringValues = element.value.toString();
            }
            else {
                WhatIsStationMeasuringValues = WhatIsStationMeasuringValues + ',' + element.value.toString();
            }
        });
        setItemPopupItemSepcQ({ ...itemPopupItemSepcQ, WhatIsStationMeasuring: e, WhatIsStationMeasuringValues: WhatIsStationMeasuringValues });
    }

    useEffect(() => {
        setLoading(true);
        OnPageload();
    }, [])
    const [editorState, setEditorState] = useState(EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(''))));
    const OnPageload = async (e) => {
        try {
            const response = await apiGet(
                '/api/infrastructure/GetInfrastructure/', {
                params: {
                    farmId: farmId
                }
            }
            );
            if (response.data.section != null) {
                var section = window.wizardDetails.filter(x => x.controllerName.toLowerCase() == pageSection.Section.toLowerCase());
                if (section.length > 0) {
                    setIsNextButtonVisible(section[0].isSectionCompleted);
                }
            }
            if (response.data.wizard.isInfrastructureRiskSaved) {
                setIsThisPageCompleted(true);
            }
            else {
                setIsThisPageCompleted(false);
            }
            setActionsCount(response.data.actionCount);
            setShow_HistoricalActions(response.data.show_HistoricalActions);
            setShow_SectionComment(response.data.show_SectionComment);
            setInfrastructure({
                ...infrastructure, outlineList: response.data.outlineList, itemList: response.data.itemList,
                itemTypes: response.data.itemTypes, uniqueItemTypes: response.data.uniqueItemTypes, itemFieldTypes: response.data.itemFeildList, lookUpList: response.data.lookUpList, SectionObj: response.data.section,
                isWizardCompleted: response.data.isFWFPCompleted, outlineCenter: response.data.outlineCenter, farmCenterTypeModel: response.data.farmCenterTypeModel
                , outlineItemTypes: response.data.outlineItemTypes, sectionComment: response.data.sectionComment
            });
            setRiskLookupList({
                ...riskLookupList, riskList: response.data.riskList, enterpriseTypes: response.data.riskModel.enterpriseTypes, luenterpriseTypes: [], contaminants: response.data.riskModel.contaminants, riskDataGroups: response.data.riskModel.riskDataGroups
                , activityGroups: response.data.riskModel.activityGroups, activitySubGroups: [], tempActivitySubGroups: response.data.riskModel.activitySubGroups, LUEnterpriseTypes: response.data.riskModel.luEnterpriseTypeList,
                categoryList: response.data.riskModel.categoryList
            })
            const content = ContentState.createFromBlockArray(convertFromHTML(response.data.sectionComment == null ? '' : response.data.sectionComment))
            setEditorState(EditorState.createWithContent(content));
            setMapDetails({ ...mapDetails, zoomLevel: response.data.selectedZoomlevel, polyType:'' });
            setLargeEnterpriseDetails({ ...largeEnterpriseDetails, isLargeEnterprise: response.data.islargeEnterprise, LMUList: response.data.lmuItemList })
            setLoading(false);
            setItemPopupHeader({ ...itemPopupHeader, watertakeTypeList: response.data.lookUpList.watertakeTypeList, LMUIds: '' })
            setToggleItemTypeListState({ ...toggleItemTypeListState, isOpen: !response.data.isFWFPCompleted, isIconUp: !response.data.isFWFPCompleted })
            if (state != null) {
                const { itemId, actionId, navigateFrom } = state;
                navigate(state.pathname, { replace: true });
                if (navigateFrom == "Actions") {
                    handleNavigateOpenActionPopup(itemId, actionId, response.data);
                }
                else {
                    editMapItemFromNavigation(itemId, response.data, navigateFrom) 
                }
            }
            let search = window.location.search;
            let params = new URLSearchParams(search);
            let navigateFrom = params.get('navigateFrom');
            if (navigateFrom == 'Actions') {
                let actionId = params.get('actionId');
                let itemId = params.get('itemId');
                let isWholeFarmAction = params.get('isWholeFarmAction');
                if (searchParams.has('actionId')) {
                    searchParams.delete('actionId');
                    setSearchParams(searchParams);
                }
                if (searchParams.has('itemId')) {
                    searchParams.delete('itemId');
                    setSearchParams(searchParams);
                }
                if (searchParams.has('isWholeFarmAction')) {
                    searchParams.delete('isWholeFarmAction');
                    setSearchParams(searchParams);
                }
                if (searchParams.has('navigateFrom')) {
                    searchParams.delete('navigateFrom');
                    setSearchParams(searchParams);
                }
                if (isWholeFarmAction == 'true') {
                    handleNavigateOpenWholeActionPopup(itemId, actionId, response.data);
                }
                else {
                    handleNavigateOpenActionPopup(itemId, actionId, response.data);
                }
            }
            //setToggleSwitch('map & details');
        } catch (err) {
            console.log(err);
        }
    }

    const resetValues = () => {
        setItemPopup({ showItemPopup: false, mapitem: [], farmId: farmId, id: 0, itemId: 0, markertype: '', canArchive: true, isMapOnly: pageSection.IsMapOnly });
        setItemPopupHeader({ page: 'Infrastructure', lmu: '', LMUIds: '', itemTypeName: '', itemTypeId: 0, Name: '', isDragged: false, Description: '', color: "#21b546", isEdited: false, itemTypeDescription: '', watertakeType:0 });
        setItemPopupMaptype({ markertype: '', area: 0.0, perimeter: 0.0, coordinates: '', });
        setItemPopupBiodiversity({ isVisible: false, isItemToBiodiversity: false, biodiversityComment: '' });
        setItemPopupRisk({
            isRisk: 'No', riskComment: '', enterprises: [], contaminants: [], riskDataGroups: [], activityGroups: [], activitySubGroups: [], likelihood: '', impact: '', category: '', significance:''
        });
        setItemPopupAchievements({ isAchievementsNotes: false, achievementsComment: '', isExpand: false });
        setItemDeletePopup({ showItemdeletePopup: false, itemId: 0 });
        setFormErrors({});
        setMapDetails({ ...mapDetails, isClear: true, polyType: '' });
        setItemPopupItemSepcQ({ AgChemicalSpillPrevention: '', DairySize: 0, IsYardRoofed: false, InShedFeeding: false, FertiliserRunoffPrevention: '', LeakageControls: '', BarnSize: 0, BarnOutdoorAreaSize: 0,
            OtherWaterTakes: 0, IsStructureLined: false, IsStructureCovered: false,  LiquidEffluentAppliedIn: 0, IsSolidsSeperatedFromLiquidEffluent: false, IsLiquidEffluentTreatedSameAsDairyEffluent: false, LiningMaterial: '',  StructureCleanedOn: 0,
            PadType: '', ShedUse: '', SilageLeachateControls: '', StockYardType: '', YardEffluentControls: '',  UnderpassEffluentManagement: '', Recycling: '', IsDischargeContained: false, PurposeOfWatertake: 0, WhatIsStationMeasuring: [], HowIsTheDataMonitored: '',  WhatIsStationMeasuringValues: '',  HAILsite: '', FrostProtectionType: '', ConsentNumber: '',
            ManageWaterUse: '', IsMarcgreenspread: false, IsMarcstored: false, ContainmentSystem: '', IsTthisWithin20m: false, IsItCovered: false, Height: 0, Thickness: 0, BufferWidth: 0,Areaperimeterbuffered: 0,DetailAnyCutOut: '',CurrentUsed: '',
        });        
    }

    /* Item select  and Clear*/
    const handleItemClick = (event, typeid, polyType) => {
        setTypeId(typeid);
        setMapDetails({ ...mapDetails, polyType: polyType, isClear: false });
        const itemFieldTypesList = infrastructure.itemFieldTypes.filter(fieldType => fieldType.itemTypeId == typeid);
        setItemPopupItemFeild({ ...itemPopupItemFeild, itemTypeId: typeid, itemFieldTypes: itemFieldTypesList });
    }

    const handleClearSelection = () => {
        setTypeId(0);
        setMapDetails({ ...mapDetails, polyType: '', isClear: true });
        setItemPopupItemFeild({ ...itemPopupItemFeild, itemTypeId: 0, itemFieldTypes: [] });
        window.location.reload(true);
    }

    const handleLMUChange = (event) => {
        var lus = '';
        let luArr = [];
        if (typeof event === 'object' && event.constructor === Object) {
            lus = event.value.toString();
        }
        else {
            event.forEach(lmu => {
                luArr.push(lmu.value);
            })
            lus = luArr.join(",");
        }

        if (lus == '') {
            setItemPopupRisk({ ...itemPopupRisk, isRisk: 'No', riskComment: '', enterprises: [], contaminants: [], riskDataGroups: [], activityGroups: [], activitySubGroups: [], likelihood: '', impact: '', category: '', significance: '' });
        }
        else if (lus != '') {
            let selectedLUEnterpriseTypes = [];
            var LUEnterpriseTypes = [];//riskLookupList.LUEnterpriseTypes.filter(lu => lu.luId == value);
            lus.split(',').forEach(lmu => {
                if (riskLookupList.LUEnterpriseTypes.filter(lu => lu.luId == parseInt(lmu)).length > 0) {
                    LUEnterpriseTypes.push(riskLookupList.LUEnterpriseTypes.filter(lu => lu.luId == parseInt(lmu)));
                }
            })
            if (LUEnterpriseTypes.length > 0) {
                let LUEnterpriseTypesArray = [];
                LUEnterpriseTypes.forEach(enterpriseArray => {
                    var array = enterpriseArray[0].enterpriseTypeList.split(',');
                    array.forEach(obj => {
                        if (LUEnterpriseTypesArray.filter(x => x == obj).length == 0) {
                            LUEnterpriseTypesArray.push(obj);
                        }
                    })
                });


                //LUEnterpriseTypesArray = LUEnterpriseTypes[0].enterpriseTypeList.split(',');

                selectedLUEnterpriseTypes = riskLookupList.enterpriseTypes.filter((el) => {
                    return LUEnterpriseTypesArray.includes(String(el.value))
                });
                if (selectedLUEnterpriseTypes.length == 0) {
                    selectedLUEnterpriseTypes = riskLookupList.enterpriseTypes.filter((el) => {
                        return el.label == 'N/A'
                    });
                }
                var displayEnterprise = false;
                if (selectedLUEnterpriseTypes.filter(x => x.label == 'N/A').length > 0) {
                    if (selectedLUEnterpriseTypes.length == 1) {
                        displayEnterprise = false;
                    }
                    else {
                        displayEnterprise = true;
                    }
                }
                else {
                    displayEnterprise = true;
                }
            }
            setRiskLookupList({ ...riskLookupList, luenterpriseTypes: selectedLUEnterpriseTypes })
            setItemPopupRisk({ ...itemPopupRisk, enterprises: [], contaminants: [], riskDataGroups: [], activityGroups: [], activitySubGroups: [], likelihood: '', impact: '', showEnterprise: displayEnterprise, category: '', significance: '' });
        }

        setItemPopupHeader({ ...itemPopupHeader, LMUIds: lus });
    }

    const handleSectionCommentChange = (e) => {
        const { name, value, checked, type } = e.target;
        setInfrastructure({ ...infrastructure, sectionComment: value })
    }

    /*ItemPopup value change Handle*/
    const handleItemPopupHeaderChange = (event) => {
        const { name, value, checked, type } = event.target;
        if (name == 'Name') {
            if (event.target.value.length > 60) {
                return false;
            }
        }
        setFormErrors({});
        setItemPopupHeader({ ...itemPopupHeader, [name]: type == 'checkbox' ? checked : value });
    }

    const handleItemPopupBiodiversity = (event) => {
        const { name, value, checked, type } = event.target;
        setItemPopupBiodiversity({ ...itemPopupBiodiversity, [name]: type == 'checkbox' ? checked : value });
    }

    const handleItemPopupRisk = (event) => {
        const { name, value, checked, type } = event.target;
        if (name == 'isRisk' && value == 'Yes') {
            setFormErrors({});
            const errors = {};
            if (itemPopupHeader.LMUIds == '') {
                errors.luid = "Please select LU";
                setFormErrors(errors);
            }
            else {
                setItemPopupRisk({ ...itemPopupRisk, [name]: type == 'checkbox' ? checked : value });
            }
        }
        else if (name == 'isRisk' && value == 'No')
        {
            setItemPopupRisk({ ...itemPopupRisk, category: '', significance:'', isRisk: 'No', riskComment: '', enterprises: [], contaminants: [], riskDataGroups: [], activityGroups: [], activitySubGroups: [], likelihood: '', impact: '', showEnterprise: true });
        }
        else {
            setItemPopupRisk({ ...itemPopupRisk, [name]: type == 'checkbox' ? checked : value });
        }  
    }

    const handleMultiSelectEnterpriseChange = (e) => {
        setItemPopupRisk({ ...itemPopupRisk, enterprises: e });
    }
    const handleMultiSelectRiskChange = (e) => {
        setItemPopupRisk({ ...itemPopupRisk, riskId: e });
    }
    const handleMultiSelectContaminantChange = (e) => {
        setItemPopupRisk({ ...itemPopupRisk, contaminants: e });
    }
    const handleMultiSelectCategoryChange = (e) => {
        setItemPopupRisk({ ...itemPopupRisk, category: e });
    }
    const handleMultiSelectRiskDataGroupChange = (e) => {
        setItemPopupRisk({ ...itemPopupRisk, riskDataGroups: e });
    }

    const handleMultiSelectActivityGroupChange = (e) => {

        setRiskLookupList({
            ...riskLookupList, activitySubGroups: []
        })
        var selectedActivitySubGroups = [];
        let myArrayFiltered = [];
        if (itemPopupRisk.activitySubGroups != undefined && itemPopupRisk.activitySubGroups.length > 0) {
            selectedActivitySubGroups = itemPopupRisk.activitySubGroups.filter((el) => {
                return e.some((f) => {
                    return f.value === el.parentId;
                });
            });
            myArrayFiltered = riskLookupList.tempActivitySubGroups.filter((el) => {
                return e.some((f) => {
                    return f.value === el.parentId;
                });
            });
        }
        else {
            myArrayFiltered = riskLookupList.tempActivitySubGroups.filter((el) => {
                return e.some((f) => {
                    return f.value === el.parentId;
                });
            });
        }
        setRiskLookupList({
            ...riskLookupList, activitySubGroups: myArrayFiltered
        })
        setItemPopupRisk({ ...itemPopupRisk, activityGroups: e, activitySubGroups: selectedActivitySubGroups });
    }

    const handleMultiSelectActivitySubGroupChange = (e) => {
        setItemPopupRisk({ ...itemPopupRisk, activitySubGroups: e });
    }

    const handleItemPopupAchievements = (event) => {
        const { name, value, checked, type } = event.target;
        setItemPopupAchievements({ ...itemPopupAchievements, [name]: type == 'checkbox' ? checked : value });
    }

    const handleItemSepcValueChange = (event) => {
        const { name, value, checked, type } = event.target;
        setItemPopupItemSepcQ({ ...itemPopupItemSepcQ, [name]: type == 'checkbox' ? checked : value });
    }

    const handleLMUSelectChange = (event) => {
        const { name, value, checked, type } = event.target;
        setLargeEnterpriseDetails({ ...largeEnterpriseDetails, [name]: type == 'checkbox' ? checked : value });
    }

    /*Item Add and Submit*/
    const addMapItem = (mapItem, maptype) => {
        let path, area = 0.0, perimeter = 0.0, coordinates = '';
        var selectedItemType = infrastructure.itemTypes.filter(item => item.id == typeid)[0];
        const ItemTypeName = selectedItemType.name;
        const isBiodiversityReq = selectedItemType.isBiodiversityReq == true ? true : false;
        let lmuId = largeEnterpriseDetails.selectedLMUId;
        const defaultColour = selectedItemType.defaultColour != null && selectedItemType.defaultColour != '' ? selectedItemType.defaultColour : "#21b546";

        /***********LMU Identification*************/
        if (maptype == 'marker') {
            largeEnterpriseDetails.LMUList.map((obj) => {
                const outlineCoordinates = obj.mapCoordinates.split(':');
                const outlinepositions = [];
                outlineCoordinates.filter(coor => coor != "").map((Coordinate) => {
                const pos = { lat: parseFloat(Coordinate.split(',')[0]), lng: parseFloat(Coordinate.split(',')[1]) }
                outlinepositions.push(pos);
                })
                const outlinePolygon = new window.google.maps.Polygon({
                paths: outlinepositions
                });
                const pos = {lat: mapItem.getPosition().lat(), lng: mapItem.getPosition().lng()}

                const inside = window.google.maps.geometry.poly.containsLocation(
                    pos,
                    outlinePolygon
                ) ? true : false;
                if (inside) {
                    lmuId = obj.id;
                }
            });           
        }
        /***********LMU Identification*************/

        if (maptype == 'marker') {

            coordinates = mapItem.getPosition().lat().toFixed(6) + ", " + mapItem.getPosition().lng().toFixed(6);
        }
        else if (maptype == 'polygon') {
            path = mapItem.getPath();
            area = (window.google.maps.geometry.spherical.computeArea(path) / 10000).toFixed(1);
            perimeter = (parseFloat(window.google.maps.geometry.spherical.computeLength(path)) / 1000).toFixed(1);
            var PolygonCoords = "";
            path.getArray().map((pointCo) => {

                PolygonCoords = PolygonCoords + pointCo.toString().replace('(', '').replace(')', '') + ":";
            })
            coordinates = PolygonCoords;
        }
        else if (maptype == 'polyline') {
            path = mapItem.getPath();
            area = 0;
            perimeter = (parseFloat(window.google.maps.geometry.spherical.computeLength(path)) / 1000).toFixed(1);
            var PolygonCoords = "";
            path.getArray().map((pointCo) => {

                PolygonCoords = PolygonCoords + pointCo.toString().replace('(', '').replace(')', '') + ":";
            })
            coordinates = PolygonCoords;
            if (path.getArray().length <= 1) {
                toast.error("This line is too short, please draw again.", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
                resetValues();
                return false;
            }
        }

        let selectedLUEnterpriseTypes = [];
        if (lmuId != 0) {
            var LUEnterpriseTypes = riskLookupList.LUEnterpriseTypes.filter(lu => lu.luId == lmuId);
            if (LUEnterpriseTypes.length != 0) {
                let LUEnterpriseTypesArray = [];

                LUEnterpriseTypesArray = LUEnterpriseTypes[0].enterpriseTypeList.split(',');

                selectedLUEnterpriseTypes = riskLookupList.enterpriseTypes.filter((el) => {
                    return LUEnterpriseTypesArray.includes(String(el.value))
                });
                if (selectedLUEnterpriseTypes.length == 0) {
                    selectedLUEnterpriseTypes = riskLookupList.enterpriseTypes.filter((el) => {
                        return el.label == 'N/A'
                    });
                }
            }
        }

        setRiskLookupList({ ...riskLookupList, luenterpriseTypes: selectedLUEnterpriseTypes})
        setItemPopup({ ...itemPopup, showItemPopup: true, mapitem: mapItem, farmId: farmId, id: 0, itemId: 0, markertype: maptype, canArchive: true, isMapOnly: pageSection.IsMapOnly });
        setItemPopupMaptype({ ...itemPopupMaptype, markertype: maptype, area: area, perimeter: perimeter, coordinates: coordinates });
        setItemPopupHeader({ ...itemPopupHeader, itemTypeName: ItemTypeName, itemTypeId: typeid, LMUId: lmuId, LMUIds: lmuId.toString(),  Name: '', isDragged: false, Description: '', color: defaultColour, isEdited: false, itemTypeDescription: selectedItemType.itemDescription, watertakeType:0 });
        setItemPopupBiodiversity({ ...itemPopupBiodiversity, isVisible: isBiodiversityReq });
        setItemPopupAchievements({ ...itemPopupAchievements, isExpand: false });
        setPopupAction("AddNew");
    }

    const handleItemSubmit = async (event) => {
        setFormErrors({});
        setSaving(true);
        const errors = {};
        let category = '';
        let enterprises = '';
        let contaminants = '';
        let riskDataGroups = '';
        let activityGroups = '';
        let activitySubGroups = '';
        var RiskId = 0;
        var RiskIds = '';
        //if (itemPopupRisk.isRisk == "Yes") {
        //    if (itemPopupRisk.riskId == 0 || itemPopupRisk.riskId == null || itemPopupRisk.riskId == undefined) {
        //        errors.riskSelection = "This is mandatory!";
        //    }
        //    else {
        //        if (typeof itemPopupRisk.riskId === 'object' && itemPopupRisk.riskId.constructor === Object) {
        //            RiskIds = itemPopupRisk.riskId.value;
        //        }
        //        else if (Array.isArray(itemPopupRisk.riskId)) {
        //            let riskArr = [];
        //            itemPopupRisk.riskId.forEach(type => {
        //                riskArr.push(type.value);
        //            })
        //            var riskValue = riskArr.join(",");
        //            RiskIds = riskValue;
        //        }
        //    }
        //}
        if (itemPopupHeader.LMUIds == null || itemPopupHeader.LMUIds == '' || itemPopupHeader.LMUIds == undefined || itemPopupHeader.LMUIds == '0') {
            errors.luid = "This is mandatory!";
        }
        setFormErrors(errors);
        
        if (Object.keys(errors).length == 0) {
            let form = {
                Id: itemPopup.id,
                MapMarkerType: itemPopup.markertype,
                FarmId: itemPopup.farmId,
                ItemId: itemPopup.itemId,
                Name: itemPopupHeader.Name,
                IsDragged: itemPopupHeader.isDragged,
                Description: itemPopupHeader.Description,
                Colour: itemPopupHeader.color,
                LMUId: itemPopupHeader.LMUId,
                ItemTypeId: itemPopupHeader.itemTypeId,
                Area: itemPopupMaptype.area,
                Length: itemPopupMaptype.perimeter,
                MapCoordinates: itemPopupMaptype.coordinates,
                IsAddsToBioDiversity: itemPopupBiodiversity.isItemToBiodiversity,
                BioDiversityComment: itemPopupBiodiversity.biodiversityComment,
                //IsItemHaveAnyRisk: itemPopupRisk.isRisk,
                RiskDescription: itemPopupRisk.riskComment,
                IsAchievementOfNote: itemPopupAchievements.isAchievementsNotes,
                AchievementOfNoteComments: itemPopupAchievements.achievementsComment,
                AgChemicalSpillPrevention: itemPopupItemSepcQ.AgChemicalSpillPrevention,
                DairySize: itemPopupItemSepcQ.DairySize,
                IsYardRoofed: itemPopupItemSepcQ.IsYardRoofed,
                InShedFeeding: itemPopupItemSepcQ.InShedFeeding,
                FertiliserRunoffPrevention: itemPopupItemSepcQ.FertiliserRunoffPrevention,
                LeakageControls: itemPopupItemSepcQ.LeakageControls,
                BarnSize: itemPopupItemSepcQ.BarnSize,
                BarnOutdoorAreaSize: itemPopupItemSepcQ.BarnOutdoorAreaSize,
                OtherWaterTakes: itemPopupItemSepcQ.OtherWaterTakes,
                IsStructureLined: itemPopupItemSepcQ.IsStructureLined,
                IsStructureCovered: itemPopupItemSepcQ.IsStructureCovered,
                LiquidEffluentAppliedIn: itemPopupItemSepcQ.LiquidEffluentAppliedIn,
                IsSolidsSeperatedFromLiquidEffluent: itemPopupItemSepcQ.IsSolidsSeperatedFromLiquidEffluent,
                IsLiquidEffluentTreatedSameAsDairyEffluent: itemPopupItemSepcQ.IsLiquidEffluentTreatedSameAsDairyEffluent,
                LiningMaterial: itemPopupItemSepcQ.LiningMaterial,
                StructureCleanedOn: itemPopupItemSepcQ.StructureCleanedOn,
                PadType: itemPopupItemSepcQ.PadType,
                ShedUse: itemPopupItemSepcQ.ShedUse,
                SilageLeachateControls: itemPopupItemSepcQ.SilageLeachateControls,
                StockYardType: itemPopupItemSepcQ.StockYardType,
                YardEffluentControls: itemPopupItemSepcQ.YardEffluentControls,
                UnderpassEffluentManagement: itemPopupItemSepcQ.UnderpassEffluentManagement,
                Recycling: itemPopupItemSepcQ.Recycling,
                WasteCollection: itemPopupItemSepcQ.WasteCollection,
                WhatIsStationMeasuring: itemPopupItemSepcQ.WhatIsStationMeasuringValues,
                HowIsTheDataMonitored: itemPopupItemSepcQ.HowIsTheDataMonitored,
                WaterMeter_Type: itemPopupItemSepcQ.WatermeterType,
                WaterMeter_DataCapture: itemPopupItemSepcQ.DataCaptureType,
                WaterMeter_RequiredbyConsent: itemPopupItemSepcQ.IsConsentRequired,
                IsDischargeContained: itemPopupItemSepcQ.IsDischargeContained,
                userId: userId,
                IsEdited: itemPopupHeader.isEdited,
                WatertakeType: itemPopupHeader.watertakeType,
                PurposeOfWatertake: itemPopupItemSepcQ.PurposeOfWatertake,
                ActivityIds: enterprises,
                ContaminantIds: contaminants,
                RiskDataGroupIds: riskDataGroups,
                ActivityGroupIds: activityGroups,
                ActivitySubGroupIds: activitySubGroups,
                RiskLikelihood: itemPopupRisk.likelihood,
                RiskImpact: itemPopupRisk.impact,
                Category: category,
                Significance: itemPopupRisk.significance,
                LMUIds: itemPopupHeader.LMUIds,
                //RiskIds: RiskIds,
                HAILsite: itemPopupItemSepcQ.HAILsite,
                FrostProtectionType: itemPopupItemSepcQ.IsFrostProtectionArea == 'Yes' ? itemPopupItemSepcQ.FrostProtectionType : null,
                ConsentNumber: itemPopupItemSepcQ.IsFrostProtectionArea == 'Yes' ?itemPopupItemSepcQ.ConsentNumber : null,
                ManageWaterUse: itemPopupItemSepcQ.IsFrostProtectionArea == 'Yes' ?itemPopupItemSepcQ.ManageWaterUse:null,
                IsMarcgreenspread: itemPopupItemSepcQ.IsMarcgreenspread,
                IsMarcstored: itemPopupItemSepcQ.IsMarcstored,
                ContainmentSystem: itemPopupItemSepcQ.ContainmentSystem,
                IsTthisWithin20m: itemPopupItemSepcQ.IsTthisWithin20m,
                IsItCovered: itemPopupItemSepcQ.IsItCovered,
                Height: itemPopupItemSepcQ.Height,
                Thickness: itemPopupItemSepcQ.Thickness,
                BufferWidth: itemPopupItemSepcQ.IsBufferZone == 'Yes' ?itemPopupItemSepcQ.BufferWidth:null,
                TypeOfBufferZone: itemPopupItemSepcQ.IsBufferZone == 'Yes' ? itemPopupItemSepcQ.TypeOfBufferZone :null,
                DetailAnyCutOut: itemPopupItemSepcQ.DetailAnyCutOut,
                CurrentUsed: itemPopupItemSepcQ.CurrentUsed, ImageUploadList: [],
                IsIrrigationArea: itemPopupItemSepcQ.IsIrrigationArea,
                IsFrostProtectionArea: itemPopupItemSepcQ.IsFrostProtectionArea,
                IsSprayArea: itemPopupItemSepcQ.IsSprayArea,
                IsBufferZone: itemPopupItemSepcQ.IsSprayArea == 'Yes' ? itemPopupItemSepcQ.IsBufferZone : null,
                OtherTypeOfBufferZone: itemPopupItemSepcQ.IsSprayArea == 'Yes' ? (itemPopupItemSepcQ.IsBufferZone == 'Yes' ? (itemPopupItemSepcQ.TypeOfBufferZone == 'Other' ? itemPopupItemSepcQ.OtherTypeOfBufferZone : null) : null ) : null
            }
            for (var i = 0; i < imageUploadList.length; i++) {
                var obj = {};
                obj.Id = imageUploadList[i].id;
                obj.ImageDetail = imageUploadList[i].imageDetail;
                obj.ImageName = imageUploadList[i].imageName;
                obj.ImagePhysicalName = imageUploadList[i].imagePhysicalName;
                obj.ImagePath = imageUploadList[i].imagePath;
                form.ImageUploadList.push(obj);
            }
            if (!Validate(form)) {

                try {
                    const response = await apiPost(
                        '/api/infrastructure/UpdateInfrastructure/', JSON.stringify(form),
                        {
                            headers: { 'Content-Type': 'application/json' },
                            withCredentials: true
                        });
                    if (response.data != null) {
                        await refreshItemDetails();
                        setSaving(false);
                        toast.success("Item details saved!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
                        handleItemPopupClose();
                    }
                } catch (error) {
                    console.error('Error:', error);
                }
            }
            else {
                setSaving(false);
            }
        }
        else {
            setSaving(false);
        }
        refreshToken();
    }

    const refreshItemDetails = async () => {
        const response = await apiGet(
            '/api/infrastructure/GetInfrastructure/', {
            params: {
                farmId: farmId
            }
        }
        );
        setActionsCount(response.data.actionCount);
        setInfrastructure({
            ...infrastructure, itemList: response.data.itemList, outlineCenter: response.data.outlineCenter
        });
    }

    const handleItemPopupClose = () => {
        resetValues();
        if (popupAction == "AddNew") {
            setTimeout(() => {
                setPopupAction("");
                const scrollableDiv = document.getElementById("bodyid");

                if (scrollableDiv) {
                    scrollableDiv.scrollTo({ top: 0, behavior: "smooth" }); // Scroll to top
                }
            }, 400);
        }
    }

    const handleMapItemEdited = (itemId, type, strValue) => {
        let name = '';
        let value = '';
        if (type == "polygonBoundsChanged") {
            name = 'mapCoordinates';
            var PolygonCoords = "";
            strValue.getArray().map((pointCo) => {
                PolygonCoords = PolygonCoords + pointCo.toString().replace('(', '').replace(')', '') + ":";
            })
            value = PolygonCoords;
        }
        else if (type == "polylineBoundsChanged") {
            name = 'mapCoordinates';
            var PolygonCoords = "";
            strValue.getArray().map((pointCo) => {
                PolygonCoords = PolygonCoords + pointCo.toString().replace('(', '').replace(')', '') + ":";
            })
            value = PolygonCoords;
        }

        const itemList = infrastructure.itemList.map(item =>
            item.itemId === itemId
                ? { ...item, [name]: value, isEdited: true }
                : item
        )
        setInfrastructure({ ...infrastructure, itemList: itemList });
    }

    /*Item Edit and Submit*/
    const editMapItem = (mapItem, itemId, isDragged) => {
        const itemDetails = infrastructure.itemList.filter(items => items.itemId == itemId)[0];
        const ItemTypeName = infrastructure.itemTypes.filter(item => item.id == itemDetails.itemTypeId)[0].name;
        const ItemDescription = infrastructure.itemTypes.filter(item => item.id == itemDetails.itemTypeId)[0].itemDescription;
        let coordinates = itemDetails.mapCoordinates;
        if (isDragged) {
            coordinates = mapItem.latLng.lat().toFixed(6) + ", " + mapItem.latLng.lng().toFixed(6);
        }
        let area = 0.0, perimeter = 0.0;
        if (itemDetails.isEdited == true) {
            if (itemDetails.mapMarkerType == "polygon") {
                const Coordinates = coordinates.split(':');
                const positions = [];
                Coordinates.filter(coor => coor != "").map((Coordinate) => {
                    const pos = { lat: parseFloat(Coordinate.split(',')[0]), lng: parseFloat(Coordinate.split(',')[1]) }
                    positions.push(pos);
                })
                const tempPolygon = new window.google.maps.Polygon({
                    paths: positions
                });

                let path = tempPolygon.getPath();
                area = (window.google.maps.geometry.spherical.computeArea(path) / 10000).toFixed(1);
                perimeter = (parseFloat(window.google.maps.geometry.spherical.computeLength(path)) / 1000).toFixed(1);
            }
            else if (itemDetails.mapMarkerType == "polyline") {
                const Coordinates = coordinates.split(':');
                const positions = [];
                Coordinates.filter(coor => coor != "").map((Coordinate) => {
                    const pos = { lat: parseFloat(Coordinate.split(',')[0]), lng: parseFloat(Coordinate.split(',')[1]) }
                    positions.push(pos);
                })

                const tempPolyline = new window.google.maps.Polyline({
                    paths: positions
                });

                let path = tempPolyline.paths;
                area = itemDetails.area;
                perimeter = (parseFloat(window.google.maps.geometry.spherical.computeLength(path)) / 1000).toFixed(1);
                if (path.length <= 1) {
                    toast.error("This line is too short, please draw again.", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
                    resetValues();
                    return false;
                }
            }
        }
        else {
            area = itemDetails.area;
            perimeter = itemDetails.length;
        }

        const isBiodiversityReq = infrastructure.itemTypes.filter(item => item.id == itemDetails.itemTypeId)[0].isBiodiversityReq == true ? true : false;
        if (itemDetails != null) {
            setItemPopup({ ...itemPopup, showItemPopup: true, mapitem: mapItem, farmId: farmId, id: itemDetails.id, itemId: itemDetails.itemId, markertype: itemDetails.mapMarkerType, canArchive: itemDetails.canArchive, isMapOnly: pageSection.IsMapOnly });
            setItemPopupMaptype({ ...itemPopupMaptype, markertype: itemDetails.mapMarkerType, area: area, perimeter: perimeter, coordinates: coordinates });
            setItemPopupHeader({
                ...itemPopupHeader, itemTypeName: ItemTypeName, itemTypeId: itemDetails.itemTypeId, LMUId: itemDetails.lmuId == null ? 0 : itemDetails.lmuId, LMUIds: itemDetails.lmuIds == null ? '' : itemDetails.lmuIds,
                Name: itemDetails.name, isDragged: isDragged, Description: itemDetails.description, color: itemDetails.colour, isEdited: itemDetails.isEdited, itemTypeDescription: ItemDescription,
                watertakeType: itemDetails.watertakeType
            });
            setItemPopupBiodiversity({
                ...itemPopupBiodiversity, isVisible: isBiodiversityReq,
                isItemToBiodiversity: itemDetails.isAddsToBioDiversity, biodiversityComment: itemDetails.bioDiversityComment
            });

            let enterpriseTypes = []
            if (itemDetails.activityIds != "" && itemDetails.activityIds != null) {
                let enterpriseTypesArray = [];

                enterpriseTypesArray = itemDetails.activityIds.split(',');

                riskLookupList.enterpriseTypes.map(type => {
                    if (enterpriseTypesArray.includes(String(type.value))) {
                        enterpriseTypes.push({
                            value: type.value,
                            label: type.label
                        })
                    }
                })
            }

            let categoryIds = []
            if (itemDetails.category != "" && itemDetails.category != null) {
                let categoryArray = [];

                categoryArray = itemDetails.category.split(',');

                riskLookupList.categoryList.map(type => {
                    if (categoryArray.includes(String(type.value))) {
                        categoryIds.push({
                            value: type.value,
                            label: type.label
                        })
                    }
                })
            }

            let ContaminantIds = []
            if (itemDetails.contaminantIds != "" && itemDetails.contaminantIds != null) {
                let ContaminantIdsArray = [];

                ContaminantIdsArray = itemDetails.contaminantIds.split(',');

                riskLookupList.contaminants.map(type => {
                    if (ContaminantIdsArray.includes(String(type.value))) {
                        ContaminantIds.push({
                            value: type.value,
                            label: type.label
                        })
                    }
                })
            }

            let riskDataGroups = []
            if (itemDetails.riskDataGroupIds != "" && itemDetails.riskDataGroupIds != null) {
                let RiskDataGroupIdsArray = [];

                RiskDataGroupIdsArray = itemDetails.riskDataGroupIds.split(',');

                riskLookupList.riskDataGroups.map(type => {
                    if (RiskDataGroupIdsArray.includes(String(type.value))) {
                        riskDataGroups.push({
                            value: type.value,
                            label: type.label
                        })
                    }
                })
            }

            let activityGroups = []
            if (itemDetails.activityGroupIds != "" && itemDetails.activityGroupIds != null) {
                let ActivityGroupIdsArray = [];

                ActivityGroupIdsArray = itemDetails.activityGroupIds.split(',');

                riskLookupList.riskDataGroups.map(type => {
                    if (ActivityGroupIdsArray.includes(String(type.value))) {
                        activityGroups.push({
                            value: type.value,
                            label: type.label
                        })
                    }
                })
            }

            setRiskLookupList({
                ...riskLookupList, activitySubGroups: []
            });

            let myArrayFiltered = [];
            if (activityGroups != undefined && activityGroups.length > 0) {
                                myArrayFiltered = riskLookupList.tempActivitySubGroups.filter((el) => {
                    return activityGroups.some((f) => {
                        return f.value === el.parentId;
                    });
                });
            }
            else {
                myArrayFiltered = riskLookupList.tempActivitySubGroups.filter((el) => {
                    return activityGroups.some((f) => {
                        return f.value === el.parentId;
                    });
                });
            }

            let activitySubGroups = []
            if (itemDetails.activitySubGroupIds != "" && itemDetails.activitySubGroupIds != null) {
                let activitySubGroupIdsArray = [];

                activitySubGroupIdsArray = itemDetails.activitySubGroupIds.split(',');

                myArrayFiltered.map(type => {
                    if (activitySubGroupIdsArray.includes(String(type.value))) {
                        activitySubGroups.push({
                            value: type.value,
                            label: type.label
                        })
                    }
                })
            }

            let riskIds = []
            if (itemDetails.riskIds != "" && itemDetails.riskIds != null) {
                let riskArray = [];

                riskArray = itemDetails.riskIds.toString().split(',');

                riskLookupList.riskList.map(type => {
                    if (riskArray.includes(String(type.value))) {
                        riskIds.push({
                            value: type.value,
                            label: type.label
                        })
                    }
                })
            }

            setItemPopupRisk({
                isRisk: itemDetails.isItemHaveAnyRisk, riskComment: itemDetails.riskDescription,
                enterprises: enterpriseTypes, contaminants: ContaminantIds, riskDataGroups: riskDataGroups,
                activityGroups: activityGroups, activitySubGroups: activitySubGroups, likelihood: itemDetails.riskLikelihood, impact: itemDetails.riskImpact, showEnterprise: true,
                category: categoryIds, significance: itemDetails.significance, riskId: riskIds
            });

            let selectedLUEnterpriseTypes = [];
            if (itemDetails.lmuId != 0) {
                var LUEnterpriseTypes = riskLookupList.LUEnterpriseTypes.filter(lu => lu.luId == itemDetails.lmuId);
                if (LUEnterpriseTypes.length != 0) {
                    let LUEnterpriseTypesArray = [];

                    LUEnterpriseTypesArray = LUEnterpriseTypes[0].enterpriseTypeList.split(',');

                    selectedLUEnterpriseTypes = riskLookupList.enterpriseTypes.filter((el) => {
                        return LUEnterpriseTypesArray.includes(String(el.value))
                    });
                }
            }

            setRiskLookupList({ ...riskLookupList, luenterpriseTypes: selectedLUEnterpriseTypes, activitySubGroups: myArrayFiltered })

            setItemPopupAchievements({ ...itemPopupAchievements, isAchievementsNotes: itemDetails.isAchievementOfNote, achievementsComment: itemDetails.achievementOfNoteComments, isExpand: false });

            const itemFieldTypesList = infrastructure.itemFieldTypes.filter(fieldType => fieldType.itemTypeId == itemDetails.itemTypeId);
            setItemPopupItemFeild({ ...itemPopupItemFeild, itemTypeId: itemDetails.itemTypeId, itemFieldTypes: itemFieldTypesList });

            setItemPopupItemSepcQ({
                AgChemicalSpillPrevention: itemDetails.agChemicalSpillPrevention,
                DairySize: itemDetails.dairySize,
                IsYardRoofed: itemDetails.isYardRoofed,
                InShedFeeding: itemDetails.inShedFeeding,
                FertiliserRunoffPrevention: itemDetails.fertiliserRunoffPrevention,
                LeakageControls: itemDetails.leakageControls,
                BarnSize: itemDetails.barnSize,
                BarnOutdoorAreaSize: itemDetails.barnOutdoorAreaSize,
                OtherWaterTakes: itemDetails.otherWaterTakes,
                IsStructureLined: itemDetails.isStructureLined,
                IsStructureCovered: itemDetails.isStructureCovered,
                LiquidEffluentAppliedIn: itemDetails.liquidEffluentAppliedIn,
                IsSolidsSeperatedFromLiquidEffluent: itemDetails.isSolidsSeperatedFromLiquidEffluent,
                IsLiquidEffluentTreatedSameAsDairyEffluent: itemDetails.isLiquidEffluentTreatedSameAsDairyEffluent,
                LiningMaterial: itemDetails.liningMaterial,
                StructureCleanedOn: itemDetails.structureCleanedOn,
                PadType: itemDetails.padType,
                ShedUse: itemDetails.shedUse,
                SilageLeachateControls: itemDetails.silageLeachateControls,
                StockYardType: itemDetails.stockYardType,
                YardEffluentControls: itemDetails.yardEffluentControls,
                UnderpassEffluentManagement: itemDetails.underpassEffluentManagement,
                Recycling: itemDetails.recycling,
                WasteCollection: itemDetails.wasteCollection,
                WhatIsStationMeasuring: itemDetails.whatIsStationMeasuringValues,
                WhatIsStationMeasuringValues: itemDetails.whatIsStationMeasuring,
                HowIsTheDataMonitored: itemDetails.howIsTheDataMonitored,
                WatermeterType: itemDetails.waterMeter_Type,
                DataCaptureType: itemDetails.waterMeter_DataCapture,
                IsConsentRequired: itemDetails.waterMeter_RequiredbyConsent,
                IsDischargeContained: itemDetails.isDischargeContained,
                PurposeOfWatertake: itemDetails.purposeOfWatertake,
                HAILsite: itemDetails.haiLsite,
                FrostProtectionType: itemDetails.frostProtectionType,
                ConsentNumber: itemDetails.consentNumber,
                ManageWaterUse: itemDetails.manageWaterUse,
                IsMarcgreenspread: itemDetails.isMarcgreenspread,
                IsMarcstored: itemDetails.isMarcstored,
                ContainmentSystem: itemDetails.containmentSystem,
                IsTthisWithin20m: itemDetails.isTthisWithin20m,
                IsItCovered: itemDetails.isItCovered,
                Height: itemDetails.height,
                Thickness: itemDetails.thickness,
                BufferWidth: itemDetails.bufferWidth,
                Areaperimeterbuffered: itemDetails.areaperimeterbuffered,
                DetailAnyCutOut: itemDetails.detailAnyCutOut,
                CurrentUsed: itemDetails.currentUsed,
                IsFrostProtectionArea: itemDetails.isFrostProtectionArea,
                IsIrrigationArea: itemDetails.isIrrigationArea,
                IsSprayArea: itemDetails.isSprayArea,
                IsBufferZone: itemDetails.isBufferZone,
                OtherTypeOfBufferZone: itemDetails.otherTypeOfBufferZone,
                TypeOfBufferZone: itemDetails.typeOfBufferZone,
            });

        }
    }

    const editMapItemFromNavigation = (itemId, infrastructure,navigateFrom) => {
        const itemDetails = infrastructure.itemList.filter(items => items.itemId == itemId)[0];
        const ItemTypeName = infrastructure.itemTypes.filter(item => item.id == itemDetails.itemTypeId)[0].name;
        const ItemDescription = infrastructure.itemTypes.filter(item => item.id == itemDetails.itemTypeId)[0].itemDescription;
        let coordinates = itemDetails.mapCoordinates;

        const isBiodiversityReq = infrastructure.itemTypes.filter(item => item.id == itemDetails.itemTypeId)[0].isBiodiversityReq == true ? true : false;
        if (itemDetails != null) {
            setItemPopup({ ...itemPopup, showItemPopup: true, mapitem: [], farmId: farmId, id: itemDetails.id, itemId: itemDetails.itemId, markertype: itemDetails.mapMarkerType, canArchive: itemDetails.canArchive, isMapOnly: pageSection.IsMapOnly });
            setItemPopupMaptype({ ...itemPopupMaptype, markertype: itemDetails.mapMarkerType, area: itemDetails.area, perimeter: itemDetails.length, coordinates: coordinates });
            setItemPopupHeader({
                ...itemPopupHeader, itemTypeName: ItemTypeName, itemTypeId: itemDetails.itemTypeId, LMUId: itemDetails.lmuId == null ? 0 : itemDetails.lmuId, LMUIds: itemDetails.lmuIds == null ? '' : itemDetails.lmuIds,
                Name: itemDetails.name, isDragged: false, Description: itemDetails.description, color: itemDetails.colour, itemTypeDescription: ItemDescription,
                watertakeType: itemDetails.watertakeType
            });
            setItemPopupBiodiversity({
                ...itemPopupBiodiversity, isVisible: isBiodiversityReq,
                isItemToBiodiversity: itemDetails.isAddsToBioDiversity, biodiversityComment: itemDetails.bioDiversityComment
            });
            let enterpriseTypes = []
            if (itemDetails.activityIds != "" && itemDetails.activityIds != null) {
                let enterpriseTypesArray = [];

                enterpriseTypesArray = itemDetails.activityIds.split(',');

                riskLookupList.enterpriseTypes.map(type => {
                    if (enterpriseTypesArray.includes(String(type.value))) {
                        enterpriseTypes.push({
                            value: type.value,
                            label: type.label
                        })
                    }
                })
            }

            let ContaminantIds = []
            if (itemDetails.contaminantIds != "" && itemDetails.contaminantIds != null) {
                let ContaminantIdsArray = [];

                ContaminantIdsArray = itemDetails.contaminantIds.split(',');

                riskLookupList.contaminants.map(type => {
                    if (ContaminantIdsArray.includes(String(type.value))) {
                        ContaminantIds.push({
                            value: type.value,
                            label: type.label
                        })
                    }
                })
            }

            let riskDataGroups = []
            if (itemDetails.riskDataGroupIds != "" && itemDetails.riskDataGroupIds != null) {
                let RiskDataGroupIdsArray = [];

                RiskDataGroupIdsArray = itemDetails.riskDataGroupIds.split(',');

                riskLookupList.riskDataGroups.map(type => {
                    if (RiskDataGroupIdsArray.includes(String(type.value))) {
                        riskDataGroups.push({
                            value: type.value,
                            label: type.label
                        })
                    }
                })
            }

            let activityGroups = []
            if (itemDetails.activityGroupIds != "" && itemDetails.activityGroupIds != null) {
                let ActivityGroupIdsArray = [];

                ActivityGroupIdsArray = itemDetails.activityGroupIds.split(',');

                riskLookupList.riskDataGroups.map(type => {
                    if (ActivityGroupIdsArray.includes(String(type.value))) {
                        activityGroups.push({
                            value: type.value,
                            label: type.label
                        })
                    }
                })
            }

            setRiskLookupList({
                ...riskLookupList, activitySubGroups: []
            });

            let myArrayFiltered = [];
            if (activityGroups != undefined && activityGroups.length > 0) {
                myArrayFiltered = riskLookupList.tempActivitySubGroups.filter((el) => {
                    return activityGroups.some((f) => {
                        return f.value === el.parentId;
                    });
                });
            }
            else {
                myArrayFiltered = riskLookupList.tempActivitySubGroups.filter((el) => {
                    return activityGroups.some((f) => {
                        return f.value === el.parentId;
                    });
                });
            }

            let activitySubGroups = []
            if (itemDetails.activitySubGroupIds != "" && itemDetails.activitySubGroupIds != null) {
                let activitySubGroupIdsArray = [];

                activitySubGroupIdsArray = itemDetails.activitySubGroupIds.split(',');

                myArrayFiltered.map(type => {
                    if (activitySubGroupIdsArray.includes(String(type.value))) {
                        activitySubGroups.push({
                            value: type.value,
                            label: type.label
                        })
                    }
                })
            }

            let categoryIds = []
            if (itemDetails.category != "" && itemDetails.category != null) {
                let categoryArray = [];

                categoryArray = itemDetails.category.split(',');

                riskLookupList.categoryList.map(type => {
                    if (categoryArray.includes(String(type.value))) {
                        categoryIds.push({
                            value: type.value,
                            label: type.label
                        })
                    }
                })
            }

            let riskIds = []
            if (itemDetails.riskIds != "" && itemDetails.riskIds != null) {
                let riskArray = [];

                riskArray = itemDetails.riskIds.toString().split(',');

                riskLookupList.riskList.map(type => {
                    if (riskArray.includes(String(type.value))) {
                        riskIds.push({
                            value: type.value,
                            label: type.label
                        })
                    }
                })
            }

            setItemPopupRisk({
                isRisk: itemDetails.isItemHaveAnyRisk, riskComment: itemDetails.riskDescription,
                enterprises: enterpriseTypes, contaminants: ContaminantIds, riskDataGroups: riskDataGroups,
                activityGroups: activityGroups, activitySubGroups: activitySubGroups, likelihood: itemDetails.riskLikelihood, impact: itemDetails.riskImpact, showEnterprise: true,
                category: categoryIds, significance: itemDetails.significance, riskId: riskIds
            });

            let selectedLUEnterpriseTypes = [];
            if (itemDetails.lmuId != 0) {
                var LUEnterpriseTypes = riskLookupList.LUEnterpriseTypes.filter(lu => lu.luId == itemDetails.lmuId);
                if (LUEnterpriseTypes.length != 0) {
                    let LUEnterpriseTypesArray = [];

                    LUEnterpriseTypesArray = LUEnterpriseTypes[0].enterpriseTypeList.split(',');

                    selectedLUEnterpriseTypes = riskLookupList.enterpriseTypes.filter((el) => {
                        return LUEnterpriseTypesArray.includes(String(el.value))
                    });
                }
            }

            setRiskLookupList({ ...riskLookupList, luenterpriseTypes: selectedLUEnterpriseTypes, activitySubGroups: myArrayFiltered })

            let isExpand = false;
            if (navigateFrom == "Achievements")
                isExpand = true
            setItemPopupAchievements({ ...itemPopupAchievements, isAchievementsNotes: itemDetails.isAchievementOfNote, achievementsComment: itemDetails.achievementOfNoteComments, isExpand: isExpand });

            const itemFieldTypesList = infrastructure.itemFeildList.filter(fieldType => fieldType.itemTypeId == itemDetails.itemTypeId);
            setItemPopupItemFeild({ ...itemPopupItemFeild, itemTypeId: itemDetails.itemTypeId, itemFieldTypes: itemFieldTypesList });

            setItemPopupItemSepcQ({
                AgChemicalSpillPrevention: itemDetails.agChemicalSpillPrevention,
                DairySize: itemDetails.dairySize,
                IsYardRoofed: itemDetails.isYardRoofed,
                InShedFeeding: itemDetails.inShedFeeding,
                FertiliserRunoffPrevention: itemDetails.fertiliserRunoffPrevention,
                LeakageControls: itemDetails.leakageControls,
                BarnSize: itemDetails.barnSize,
                BarnOutdoorAreaSize: itemDetails.barnOutdoorAreaSize,
                OtherWaterTakes: itemDetails.otherWaterTakes,
                IsStructureLined: itemDetails.isStructureLined,
                IsStructureCovered: itemDetails.isStructureCovered,
                LiquidEffluentAppliedIn: itemDetails.liquidEffluentAppliedIn,
                IsSolidsSeperatedFromLiquidEffluent: itemDetails.isSolidsSeperatedFromLiquidEffluent,
                IsLiquidEffluentTreatedSameAsDairyEffluent: itemDetails.isLiquidEffluentTreatedSameAsDairyEffluent,
                LiningMaterial: itemDetails.liningMaterial,
                StructureCleanedOn: itemDetails.structureCleanedOn,
                PadType: itemDetails.padType,
                ShedUse: itemDetails.shedUse,
                SilageLeachateControls: itemDetails.silageLeachateControls,
                StockYardType: itemDetails.stockYardType,
                YardEffluentControls: itemDetails.yardEffluentControls,
                UnderpassEffluentManagement: itemDetails.underpassEffluentManagement,
                Recycling: itemDetails.recycling,
                WasteCollection: itemDetails.wasteCollection,
                WhatIsStationMeasuring: itemDetails.whatIsStationMeasuringValues,
                WhatIsStationMeasuringValues: itemDetails.whatIsStationMeasuring,
                HowIsTheDataMonitored: itemDetails.howIsTheDataMonitored,
                WatermeterType: itemDetails.waterMeter_Type,
                DataCaptureType: itemDetails.waterMeter_DataCapture,
                IsConsentRequired: itemDetails.waterMeter_RequiredbyConsent,
                IsDischargeContained: itemDetails.isDischargeContained,
                PurposeOfWatertake: itemDetails.purposeOfWatertake,
                HAILsite: itemDetails.hAILsite,
                FrostProtectionType: itemDetails.frostProtectionType,
                ConsentNumber: itemDetails.consentNumber,
                ManageWaterUse: itemDetails.manageWaterUse,
                IsMarcgreenspread: itemDetails.isMarcgreenspread,
                IsMarcstored: itemDetails.isMarcstored,
                ContainmentSystem: itemDetails.containmentSystem,
                IsTthisWithin20m: itemDetails.isTthisWithin20m,
                IsItCovered: itemDetails.isItCovered,
                Height: itemDetails.height,
                Thickness: itemDetails.thickness,
                BufferWidth: itemDetails.bufferWidth,
                Areaperimeterbuffered: itemDetails.areaperimeterbuffered,
                DetailAnyCutOut: itemDetails.detailAnyCutOut,
                CurrentUsed: itemDetails.currentUsed,
                IsFrostProtectionArea: itemDetails.isFrostProtectionArea,
                IsIrrigationArea: itemDetails.isIrrigationArea,
                IsSprayArea: itemDetails.isSprayArea,
                IsBufferZone: itemDetails.isBufferZone,
                OtherTypeOfBufferZone: itemDetails.otherTypeOfBufferZone,
                TypeOfBufferZone: itemDetails.typeOfBufferZone,
            });

            setToggleItemTypeState({ itemTypeId: itemDetails.itemTypeId, isOpen: true, isIconUp: true });
            setToggleItemState({ itemId: itemId, isOpen: true, isIconUp: true });
        }
    } 

    const handleItemEditPopup = (itemId) => {
        editMapItem([], itemId, false)
    }

    /*Item Delete*/
    const handleItemDeletePopup = (itemId) => {
        setItemDeletePopup({ showItemDeletePopup: true, itemId: itemId });
    }

    const handleItemDeletePopupClose = () => {
        setItemDeletePopup({ showItemDeletePopup: false, itemId: 0 });
    }

    const deleteItem = async (event) => {
        setItemDeleteSaving(true);
        const itemid = itemDeletePopup.itemId;
        try {
            const response = await apiGet(
                '/api/infrastructure/DeleteItem/', {
                params: {
                    itemId: itemid, userId: userId
                }
            });
            if (response.data != null) {
                await refreshItemDetails();
                setItemDeleteSaving(false);
                handleItemDeletePopupClose();
                handleItemPopupClose();
            }
        } catch (error) {
            console.error('Error:', error);
        }
    }

    /*Item- Action Popup handle*/
    const handleOpenActionPopup = (itemId, actionId) => {
        const itemDetails = infrastructure.itemList.filter(items => items.itemId == itemId)[0];
        setActionPopup({ isHavingItemBasedAction: itemDetails.isHavingItemBasedAction, showActionPopup: true, itemId: itemId, itemTypeId: itemDetails.itemTypeId, itemName: itemDetails.name, actionId: actionId });
    };

    const handleOpenWholeActionPopup = (itemId, actionId) => {
        setWholeFarmActionPopup({ showActionPopup: true, itemId: itemId, itemTypeId: infrastructure.outlineCenter.itemTypeId, itemName: 'Map Centre', actionId: actionId });
    };

    const handleActionClose = async() => {
        setActionPopup({ showActionPopup: false, itemId: 0, itemTypeId: 0, itemName: '', actionId: 0 });
    }

    const handleWholeActionClose = () => {
        setWholeFarmActionPopup({ showActionPopup: false, itemId: 0, itemTypeId: 0, itemName: '', actionId: 0 });
    }

    const handleNavigateOpenActionPopup = (itemId, actionId, infrastructure) => {
        const itemDetails = infrastructure.itemList.filter(items => items.itemId == itemId)[0];
        setActionPopup({ showActionPopup: true, itemId: itemId, itemTypeId: itemDetails.itemTypeId, itemName: itemDetails.name, actionId: actionId });
    };
    const handleNavigateOpenWholeActionPopup = (itemId, actionId, infrastructure) => {
        setWholeFarmActionPopup({ showActionPopup: true, itemId: itemId, itemTypeId: infrastructure.outlineCenter.itemTypeId, itemName: 'NA', actionId: actionId });
    };
    /*Item- MaintenancePlan Popup handle*/
    const handleOpenMaintenancePlanPopup = (itemId) => {
        const itemDetails = infrastructure.itemList.filter(items => items.itemId == itemId)[0];
        setMaintenancePlanPopup({ ...maintenancePlanPopup, showMaintenancePlanPopup: true, itemId: itemId, itemName: itemDetails.name, itemTypeId: itemDetails.itemTypeId, actionId: 0 });
    }

    const handleMaintenancePlanClose = () => {
        setMaintenancePlanPopup({ ...maintenancePlanPopup, showMaintenancePlanPopup: false, itemId: 0, itemTypeId: 0, itemName: '', actionId: 0 });
    }

    /*handle Toggle for nonMap View*/
    const handleItemTypeListTogole = (isOpen, isIconUp) => {
        setToggleItemTypeListState({ ...toggleItemTypeListState, isOpen: isOpen, isIconUp: isIconUp})
    }

    const handleItemTypeTogole = (itemTypeId,isOpen, isIconUp,) => {
        setToggleItemTypeState({ ...toggleItemTypeState, itemTypeId: itemTypeId, isOpen: isOpen, isIconUp: isIconUp})
    }

    const handleItemTogole = (itemId, isOpen, isIconUp ) => {
        setToggleItemState({ ...toggleItemState, itemId: itemId, isOpen: isOpen, isIconUp: isIconUp})
    }

    /*handle Item highlight*/
    const handleItemHighlight = (itemId) => {
        setMapDetails({ ...mapDetails, highlighteditemId: itemId })
    }

    const handleRiskSummaryClose = () => {
        setRiskSummaryPopup({ ...riskSummaryPopup, showriskSummary: false })
        window.location.reload(true);
    }

    const handleRiskSummaryOpen = () => {
        setRiskSummaryPopup({ ...riskSummaryPopup, showriskSummary: true })
    }

    /*Avoid unwanted page refresh*/
    const mapView = useMemo(() => {
        return (
            <MapView width={toggleSwitch == 'map' ? '80vw' : '50vw'}
                height={toggleSwitch == 'map' ? '80vw' : '50vw'}
                itemModel={infrastructure}
                mapDetails={mapDetails}
                largeEnterpriseDetails={largeEnterpriseDetails}
                addMapItem={addMapItem}
                editMapItem={editMapItem}
                handleMapItemEdited={handleMapItemEdited}
            ></MapView>
        )
    }, [infrastructure, mapDetails, largeEnterpriseDetails, toggleSwitch])

    const itemTypeListView = useMemo(() => {

        return (
            <ItemTypeListViewForMap isWizardCompleted={infrastructure.isWizardCompleted} Section={infrastructure.Section}
                itemTypesList={infrastructure.itemTypes}
                toggleItemTypeListState={toggleItemTypeListState}
                handleClearSelection={handleClearSelection}
                handleItemClick={handleItemClick}
                handleItemTypeListTogole={handleItemTypeListTogole}
                itemModel={infrastructure}
            >
            </ItemTypeListViewForMap>
        )
    }, [infrastructure, largeEnterpriseDetails, infrastructure.SectionObj, toggleItemTypeListState, toggleItemTypeState, toggleItemState, infrastructure.outlineCenter])

    const nonMapView = useMemo(() => {
        return (
            <NonMapView show_HistoricalActions={show_HistoricalActions} itemModel={infrastructure} handleSectionCommentChange={handleSectionCommentChange}
                toggleItemTypeListState={toggleItemTypeListState}
                toggleItemTypeState={toggleItemTypeState}
                toggleItemState={toggleItemState}
                handleClearSelection={handleClearSelection}
                handleItemClick={handleItemClick}
                handleItemEditPopup={handleItemEditPopup}
                handleItemDeletePopup={handleItemDeletePopup}
                handleOpenActionPopup={handleOpenActionPopup}
                sectionObj={infrastructure.SectionObj}
                largeEnterpriseDetails={largeEnterpriseDetails}
                handleLMUSelectChange={handleLMUSelectChange}
                handleItemTypeListTogole={handleItemTypeListTogole}
                handleItemTypeTogole={handleItemTypeTogole}
                handleItemTogole={handleItemTogole} handleOpenWholeActionPopup={handleOpenWholeActionPopup}
                handleItemHighlight={handleItemHighlight} outlineCenter={infrastructure.outlineCenter}
            ></NonMapView>
        )
    }, [infrastructure, largeEnterpriseDetails, infrastructure.SectionObj, toggleItemTypeListState, toggleItemTypeState, toggleItemState, infrastructure.outlineCenter])

    const toggleSwitchChange = (e) => {
        setToggleSwitch(e)
        if (e == 'map') {
            document.getElementById('mapView').style.display = 'block';
            document.getElementById('itemTypeListView').style.display = 'block';
            document.getElementById('nonMapView').style.display = 'none';
            document.getElementById('itemTypeListView').style.height = '70vh';
        }
        else if (e == 'details') {
            document.getElementById('mapView').style.display = 'none';
            document.getElementById('nonMapView').style.display = 'block';
            document.getElementById('itemTypeListView').style.display = 'none';
            document.getElementById('nonMapView').style.width = '50vw';
        }
        else {
            document.getElementById('mapView').style.display = 'block';
            document.getElementById('nonMapView').style.display = 'block';
            document.getElementById('itemTypeListView').style.display = 'none';
            document.getElementById('nonMapView').style.width = '50vw';
        }
    }

    const [checkActionPopup, setCheckActionPopup] = useState({ showPopup: false, section: '', method: '' });
    const handleCheckActionPopupClose = () => {
        setCheckActionPopup({ showPopup: false, section: '', method: '' });
    }
    const handleCheckCalculatorDataPopupConfirm = () => {
        if (checkActionPopup.method == 'handleWizardChanged') {
            handleWizardChanged(checkActionPopup.section);
        }
        else if (checkActionPopup.method == 'handleMoveToNextPage') {
            handleMoveToNextPage(checkActionPopup.section);
        }
        else if (checkActionPopup.method == 'handleWizardChangedBack') {
            handleWizardChangedBack(checkActionPopup.section);
        }
    }
    const checkAction = async (section, method) => {
        await SaveSectionComment();
        if (!isThisPageCompleted && actionsCount == 0) {
            setCheckActionPopup({ showPopup: true, section: section, method: method });
        }
        else {
            if (method == 'handleWizardChanged') {
                handleWizardChanged(section);
            }
            else if (method == 'handleMoveToNextPage') {
                handleMoveToNextPage(section);
            }
            else if (method == 'handleWizardChangedBack') {
                handleWizardChangedBack(section);
            }
        }
    }

    const handlePageChange = async (section, method) => {
        await SaveSectionComment();
        if (method == 'handleWizardChanged') {
            handleWizardChanged(section);
        }
        else if (method == 'handleMoveToNextPage') {
            handleMoveToNextPage(section);
        }
        else if (method == 'handleWizardChangedBack') {
            handleWizardChangedBack(section);
        }
    }
    const [savingSectionComment, setSavingSectionComment] = useState('');
    const saveSectionComment = async () => {
        setSavingSectionComment(true);
        try {
            var form = {
                farmId: farmId,
                comment: draftToHtml(convertToRaw(editorState.getCurrentContent()))//infrastructure.sectionComment
            };
            const response = await apiPost(
                '/api/infrastructure/SaveSectionComment/', JSON.stringify(form),
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                });
            if (response) {
                setSavingSectionComment(false);
            }
        } catch (err) {
            console.log(err);
            setSavingSectionComment(false);
        }
    }
    const SaveSectionComment = async () => {
        try {
            var form = {
                farmId: farmId,
                comment: draftToHtml(convertToRaw(editorState.getCurrentContent()))
            };
            const response = await apiPost(
                '/api/infrastructure/SaveSectionComment/', JSON.stringify(form),
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                });

        } catch (err) {
            console.log(err);
        }
    }

    const handleEditItemClick = (e) => {
        if (e.target.checked) {
            toast.error(
                (t) => (
                    <div>
                        <span>ALERT: when editing a shape remember to click inside the shape when finished, or when editing a line double click on the line, to save any changes.</span>
                        <button className="toast-close-button"
                            onClick={() => toast.dismiss(t.id)}
                        >
                            OK
                        </button>
                    </div>
                ),
                {
                    duration: Infinity, style: { border: '1px solid #f76054', padding: '16*/px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', }
                }
            );
        }
        setMapDetails({ ...mapDetails, isFarmCenterEditable: !mapDetails.itemsEditable, isFarmOutlineEditable: !mapDetails.itemsEditable, itemsEditable: !mapDetails.itemsEditable })
    }
    

    return (
        <div>
            {!infrastructure.isMapOnly &&
                <Modal isOpen={checkActionPopup.showPopup}>
                    <ModalHeader toggle={handleCheckActionPopupClose} >Confirm</ModalHeader>
                    <ModalBody>
                        Confirm : you have not created any actions on this page. Are you sure you wish to continue? Select ‘No’ if you wish to stay on this page to finish creating actions, or Yes to continue.
                    </ModalBody>
                    <ModalFooter>
                        <Button onClick={handleCheckCalculatorDataPopupConfirm} color="primary">
                            Yes
                        </Button>{' '}
                        <Button color="danger" onClick={handleCheckActionPopupClose}>No</Button>
                    </ModalFooter>
                </Modal>
            }
            <ToastContainer position="top-center" containerStyle={{ top: '50%' }} />
            <Toaster position="top-center" containerStyle={{ top: '50%' }} />
            <Row>
                <Col> {infrastructure.isMapOnly ? <h3 className="header3">Identify Infrastructure and Areas</h3> : <h3 className="header3">Infrastructure</h3>} </Col>
                <Col>
                    {!loading &&
                        <>
                        {infrastructure.isMapOnly &&
                            <>
                                {(roleName == 'SWNZ Admin' || farmRoleName == 'SWNZ Admin' || farmRoleName == 'Manager') &&
                                    <Button className="float-end btn-next-page" onClick={(section) => handlePageChange(infrastructure.Section, 'handleWizardChanged')}>Next <FaChevronRight /> </Button>
                            }
                            {
                                (roleName != 'SWNZ Admin' && farmRoleName != 'SWNZ Admin' && farmRoleName != 'Manager') &&isNextButtonVisible&&
                                <Button className="float-end btn-next-page" onClick={(section) => handlePageChange(infrastructure.Section, 'handleMoveToNextPage')}>Next <FaChevronRight /> </Button>
                            }
                            </>
                        }
                        {!infrastructure.isMapOnly &&
                            <>
                                {(roleName == 'SWNZ Admin' || farmRoleName == 'SWNZ Admin' || farmRoleName == 'Manager') &&
                                    <Button className="float-end btn-next-page" onClick={(section) => checkAction(infrastructure.Section, 'handleWizardChanged')}>Next <FaChevronRight /> </Button>
                                }
                                {
                                (roleName != 'SWNZ Admin' && farmRoleName != 'SWNZ Admin' && farmRoleName != 'Manager') && isNextButtonVisible &&
                                    <Button className="float-end btn-next-page" onClick={(section) => handlePageChange(infrastructure.Section, 'handleMoveToNextPage')}>Next <FaChevronRight /> </Button>
                                }
                            </>
                        }
                        <Button className="float-end btn-next-page" onClick={(section) => handlePageChange(infrastructure.Section, 'handleWizardChangedBack')}>Back <FaChevronLeft /> </Button>
                        </>
                    }
                </Col>
                
            </Row>
            <br/>
            {loading ? <SpinnerContainer /> :
                <div>
                    <Row style={{ marginTop: '10px' }}>
                        <Col id='mapView'>
                            <Row className="map-layer">
                                <Col>
                                    <Row>
                                        <Col sm="3"> {toggleSwitch == 'map & details' &&
                                            <Button size="sm" id="btnShowFullmap" style={{ backgroundColor: "#41533d" }} className="btn" onClick={(e) => toggleSwitchChange('map')}>Full Map&nbsp;&nbsp;
                                                <img src="/images/button-details_expand.png" className="card_icon" ></img>
                                            </Button>
                                        }
                                            {toggleSwitch == 'map' &&
                                                <Button size="sm" id="btnShowFullmap" style={{ backgroundColor: "#41533d" }} className="btn" onClick={(e) => toggleSwitchChange('map & details')}>Small Map&nbsp;&nbsp;
                                                    <img src="/images/button-details_contract.png" style={{}} className="card_icon" ></img>
                                                </Button>
                                            }
                                        </Col>
                                        <Col sm="1"></Col>
                                        <Col sm="8">
                                            <div className="map-item-edit-div">
                                                <Label className="map-checkbox-label">Show LU layer</Label>
                                                <Input className="map-item-edit-checkbox" style={{}} type="checkbox" checked={largeEnterpriseDetails.isSmallEnterpriseShow} onChange={(e) => setLargeEnterpriseDetails({ ...largeEnterpriseDetails, isSmallEnterpriseShow: !largeEnterpriseDetails.isSmallEnterpriseShow })} name="isSmallEnterpriseShow" id="isSmallEnterpriseShow" />&nbsp;&nbsp;
                                                <Label className="map-checkbox-label">Edit Item</Label>
                                                <Input className="map-item-edit-checkbox" style={{}} type="checkbox" checked={mapDetails.itemsEditable} onChange={(e) => handleEditItemClick(e)} name="isItemEdit" id="isItemEdit" />&nbsp;&nbsp;
                                                <Label className="map-checkbox-label">Show Label</Label>
                                                <Input className="map-item-edit-checkbox" style={{}} type="checkbox" checked={mapDetails.showLabel} onChange={(e) => setMapDetails({ ...mapDetails, showLabel: !mapDetails.showLabel })} name="showLabel" id="showLabel" />&nbsp;&nbsp;
                                            </div>
                                        </Col>
                                    </Row>
                                    {mapView}
                                </Col>
                            </Row>
                            
                        </Col>
                        <Col id="itemTypeListView" style={{ display: toggleSwitch == 'map' ? 'block' : 'none', height: "70vh", overflowY: "scroll", width: "20vw" }}>
                            <br />
                            {itemTypeListView}
                            <br />
                        </Col>
                        <Col id='nonMapView' style={{ width: "50vw", display: toggleSwitch == 'map' ? 'none' : 'block', marginTop: "-25px" }}>
                            <Row>
                                <Col>
                                    {toggleSwitch == 'map & details' &&
                                        <Button size="sm" id="btnShowFulldetails" style={{ backgroundColor: "#41533d" }} className="btn btnExpandContract" onClick={(e) => toggleSwitchChange('details')}>Full Details&nbsp;&nbsp;
                                            <img src="/images/button-details_expand.png" style={{}} className="card_icon" ></img>
                                        </Button>
                                    }
                                    {toggleSwitch == 'details' &&
                                        <Button size="sm" id="btnShowFulldetails" style={{ backgroundColor: "#41533d" }} className="btn btnExpandContract" onClick={(e) => toggleSwitchChange('map & details')}>Small Details&nbsp;&nbsp;
                                            <img src="/images/button-details_contract.png" style={{}} className="card_icon" ></img>
                                        </Button>
                                    }
                                    {
                                        !loading && !infrastructure.isMapOnly && <Button style={{ marginLeft: "0.5vw", backgroundColor: "#41533d" }}  onClick={() => handleRiskSummaryOpen()} className="btn btn-risk-summaryv1">View Risk and Action Summary</Button>
                                    }
                                </Col>
                            </Row>
                            {show_SectionComment &&
                                <>
                                <Row style={{ marginTop: "0.5vh" }}>
                                    <Col sm="12">
                                        <FormGroup>
                                            <Label for="sectionComment" className="text-capitalize" style={{ fontSize: "16px" }}><b>Section Comment</b> <span className="text-lowercase">(add any information around the features, actions, or risks, that have been considered on this page)</span></Label>
                                            <Editor handlePastedText={() => false}
                                                defaultEditorState={editorState}
                                                onEditorStateChange={setEditorState}
                                                wrapperClassName="wrapper-class"
                                                editorClassName="editor-class"
                                                toolbarClassName="toolbar-class"
                                                toolbar={
                                                    {
                                                        options: ['inline'], inline: {
                                                            inDropdown: false,
                                                            options: ['bold', 'italic', 'underline'],
                                                        }
                                                    }
                                                }
                                            />
                                        </FormGroup>

                                    </Col>
                                    <Col sm="12">
                                        {savingSectionComment ?
                                            <Button style={{ float: "right" }} onClick={saveSectionComment} color="success" disabled>
                                                <Row>
                                                    <Col sm="8">
                                                        <span>
                                                            {' '}Saving
                                                        </span>
                                                    </Col>
                                                    <Col sm="4">
                                                        <Spinner size="sm">
                                                            Saving...
                                                        </Spinner>
                                                    </Col>
                                                </Row>
                                            </Button>
                                            :
                                            <Button style={{ float: "right" }} onClick={saveSectionComment} color="success" size="sm">
                                                Save
                                            </Button>
                                        }
                                    </Col>
                                </Row>
                                <br />
                                </>    
                            }
                            
                            <Row>
                                <Col>
                                    {nonMapView}
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </div>
            }
            <Modal size="lg" isOpen={itemPopup.showItemPopup} backdrop={false} className="itemPopup">
                <Form>
                    <ModalHeader toggle={handleItemPopupClose} >Add/Edit Item</ModalHeader>
                    <ModalBody>
                        <ItemCommonTop setFormErrors={setFormErrors} Section={infrastructure.Section} handleLMUChange={handleLMUChange} itemPopupHeader={itemPopupHeader} itemPopupMaptype={itemPopupMaptype} itemPopupBiodiversity={itemPopupBiodiversity} itemPopupRisk={itemPopupRisk}
                            largeEnterpriseDetails={largeEnterpriseDetails} formErrors={formErrors} riskLookupList={riskLookupList}
                            handleItemPopupHeaderChange={handleItemPopupHeaderChange}
                            handleItemPopupBiodiversity={handleItemPopupBiodiversity}
                            handleItemPopupRisk={handleItemPopupRisk} handleMultiSelectRiskChange={handleMultiSelectRiskChange}
                            handleMultiSelectEnterpriseChange={handleMultiSelectEnterpriseChange}
                            handleMultiSelectContaminantChange={handleMultiSelectContaminantChange}
                            handleMultiSelectRiskDataGroupChange={handleMultiSelectRiskDataGroupChange}
                            handleMultiSelectActivityGroupChange={handleMultiSelectActivityGroupChange}
                            handleMultiSelectActivitySubGroupChange={handleMultiSelectActivitySubGroupChange}
                            handleMultiSelectCategoryChange={handleMultiSelectCategoryChange} setRiskLookupList={setRiskLookupList} setItemPopupRisk={setItemPopupRisk}
                        ></ItemCommonTop>
                        <InfrastructureItemSpecView handleMultiSelectChange={handleMultiSelectChange} handleItemPopupHeaderChange={handleItemPopupHeaderChange} itemPopupHeader={itemPopupHeader} itemPopupItemFeild={itemPopupItemFeild} itemPopupItemSepcQ={itemPopupItemSepcQ} lookUpList={infrastructure.lookUpList}
                            handleItemSepcValueChange={handleItemSepcValueChange}></InfrastructureItemSpecView>
                        <ItemCommonBottom setImageUploadList={setImageUploadList} imageUploadList={imageUploadList} itemPopup={itemPopup} itemPopupAchievements={itemPopupAchievements}
                            handleItemPopupAchievements={handleItemPopupAchievements}></ItemCommonBottom>
                    </ModalBody>

                    <ItemFooter saving={saving} itemPopup={itemPopup}
                        handleItemDeletePopup={handleItemDeletePopup}
                        handleItemSubmit={handleItemSubmit}
                        handleItemPopupClose={handleItemPopupClose}
                        handleOpenActionPopup={handleOpenActionPopup}
                        handleOpenMaintenancePlanPopup={handleOpenMaintenancePlanPopup}>
                    </ItemFooter>
                </Form>
            </Modal>
            <Modal isOpen={itemDeletePopup.showItemDeletePopup}>
                <ModalHeader toggle={handleItemDeletePopupClose} >Archive the item</ModalHeader>
                <ModalBody>
                    Do you want to archive the item ?
                </ModalBody>
                <ModalFooter>
                    {itemDeletesaving ?
                        <>
                            <Button onClick={deleteItem} color="primary" disabled>
                                <Row>
                                    <Col sm="6">
                                        <span>
                                            {' '}Saving
                                        </span>
                                    </Col>
                                    <Col sm="6">
                                        <Spinner size="sm">
                                            Saving...
                                        </Spinner>
                                    </Col>
                                </Row></Button>{' '}
                        </>
                        :
                        <>
                            <Button onClick={deleteItem} color="primary">
                                Yes
                            </Button>{' '}
                        </>
                    }
                    <Button color="danger" onClick={handleItemDeletePopupClose}>No</Button>
                </ModalFooter>
            </Modal>

            {actionPopup.showActionPopup && !actionPopup.isHavingItemBasedAction && <Action refreshToken={refreshToken} width={width} height={height} refreshItemDetails={refreshItemDetails} itemList={infrastructure.itemList} redirectPage="/infrastructure" selectedLUId={largeEnterpriseDetails.selectedLMUId}
                handleActionClose={handleActionClose} itemTypeId={actionPopup.itemTypeId} sectionName={infrastructure.Section} sectionId={infrastructure.itemTypes[0].sectionId} itemId={actionPopup.itemId} itemName={actionPopup.itemName}
                showActionPopupModal={actionPopup.showActionPopup} actionId={actionPopup.actionId} itemTypeSelect={infrastructure.itemTypes} itemTypeDisabled={true} wholeFarmAction={false} ></Action>}

            {actionPopup.showActionPopup && actionPopup.isHavingItemBasedAction && <ItemBasedAction refreshToken={refreshToken} width={width} height={height} refreshItemDetails={refreshItemDetails} itemList={infrastructure.itemList} redirectPage="/infrastructure" selectedLUId={largeEnterpriseDetails.selectedLMUId}
                handleActionClose={handleActionClose} itemTypeId={actionPopup.itemTypeId} sectionName={infrastructure.Section} sectionId={infrastructure.itemTypes[0].sectionId} itemId={actionPopup.itemId} itemName={actionPopup.itemName}
                showActionPopupModal={actionPopup.showActionPopup} actionId={actionPopup.actionId} itemTypeSelect={infrastructure.itemTypes} itemTypeDisabled={true} wholeFarmAction={false} ></ItemBasedAction>}

            {wholeFarmActionPopup.showActionPopup && <Action refreshToken={refreshToken} width={width} height={height} refreshItemDetails={refreshItemDetails} itemList={infrastructure.itemList} redirectPage="/infrastructure" selectedLUId={largeEnterpriseDetails.selectedLMUId}
                handleActionClose={handleWholeActionClose} itemTypeId={wholeFarmActionPopup.itemTypeId} sectionName={infrastructure.Section} sectionId={infrastructure.itemTypes[0].sectionId} itemId={wholeFarmActionPopup.itemId} itemName={wholeFarmActionPopup.itemName}
                showActionPopupModal={wholeFarmActionPopup.showActionPopup} actionId={wholeFarmActionPopup.actionId} itemTypeSelect={infrastructure.outlineItemTypes} itemTypeDisabled={true} wholeFarmAction={true}></Action>}

            {riskSummaryPopup.showriskSummary && <RiskSummary refreshToken={refreshToken} section={infrastructure.SectionObj} sectionId={infrastructure.itemTypes[0].sectionId} riskSummaryPopup={riskSummaryPopup} handleRiskSummaryClose={handleRiskSummaryClose}></RiskSummary>}

            {maintenancePlanPopup.showMaintenancePlanPopup && <MaintenancePlan handleMaintenancePlanClose={handleMaintenancePlanClose}
                showMaintenancePlanPopupModal={maintenancePlanPopup.showMaintenancePlanPopup}
                actionId={maintenancePlanPopup.actionId} itemId={maintenancePlanPopup.itemId} itemName={maintenancePlanPopup.itemName} itemTypeId={maintenancePlanPopup.itemTypeId}
                itemTypeSelect={infrastructure.itemTypes} sectionName={infrastructure.Section} redirectPage="/infrastructure">
            </MaintenancePlan>}
        </div>
    )
}
export default Infrastructure;